import { Ship, Sailboat, Wrench, Box, CarFront, Container } from "lucide-react";

export const SERVICES = [
  {
    slug: "boat-modifications",
    title: "Boat Modifications",
    tag: "Most Popular",
    icon: Ship,
    image: "/work/boat-console.jpg",
    desc: "Custom aluminium boat mods built around how you actually use your boat.",
    detail: "Our most popular work by far. Whether it's a weekend tinny or a serious offshore rig, we design and fabricate aluminium modifications that make your boat fish better, ride better and last longer.",
    bullets: ["Casting decks & raised platforms", "Rod holders, bait boards & rocket launchers", "Fuel tanks & transom work", "Hull extensions & pods", "Full custom fit-outs"],
  },
  {
    slug: "kit-boat-builds",
    title: "Kit Boat Builds",
    tag: "Boats",
    icon: Sailboat,
    image: "/work/kit-boat.jpg",
    desc: "Complete kit boat builds — assembled, welded and finished in-house.",
    detail: "Start with a flat-pack aluminium kit and end with a boat that's ready for the water. We assemble, weld and finish kit boats right here in Albany, with all the custom touches along the way.",
    bullets: ["Kit assembly & welding", "Hull fit-out & finishing", "Console, floor & casting decks", "Trailer packages available", "Ready-for-the-water handover"],
  },
  {
    slug: "boat-maintenance",
    title: "Boat Maintenance",
    tag: "Marine",
    icon: Wrench,
    image: "/work/trailer-chassis.jpg",
    desc: "Repairs, welding and checkovers that keep you safe on the water.",
    detail: "Salt water is brutal on aluminium. From crack repairs to corrosion cut-outs and pre-season checkovers, we keep your hull sound and your fittings solid so you can focus on the fishing.",
    bullets: ["Hull crack & corrosion repairs", "Welding of marine grade ally.", "Trailers, bunks & fittings", "Pre-season safety checkovers", "Insurance repair work"],
  },
  {
    slug: "toolboxes",
    title: "Toolboxes",
    tag: "Fabrication",
    icon: Box,
    image: "/work/toolbox-drawers.jpg",
    desc: "Heavy-duty aluminium toolboxes made to measure.",
    detail: "Off-the-shelf boxes never quite fit. We build toolboxes to your exact dimensions — for utes, trucks, trailers and workshops — with proper seals, reinforced lids and hardware that won't let you down.",
    bullets: ["Made-to-measure sizing", "Ute, truck & trailer fit-outs", "Dust & water resistant seals", "Underbody & drawer systems", "Whale tail & T-lock hardware"],
  },
  {
    slug: "canopies",
    title: "Canopies",
    tag: "Fabrication",
    icon: CarFront,
    image: "/work/canopy-austin.jpg",
    desc: "Dust-proof, water-tight canopies for touring and trade.",
    detail: "A canopy should survive the corrugations, not rattle apart on them. Our aluminium canopies are engineered light, sealed tight and set up exactly how you need — trade, touring or both.",
    bullets: ["Custom canopy builds", "Lift-off & jack-off designs", "Internal fit-outs & shelving", "Roof rack & awning mounts", "Dual-cab, space-cab & single-cab"],
  },
  {
    slug: "trailers",
    title: "Trailers",
    tag: "Fabrication",
    icon: Container,
    image: "/work/hull-bow.jpg",
    desc: "Repairs, rebuilds and custom trailer fabrication done properly.",
    detail: "From boat trailers copping salt water every weekend to work trailers earning their keep, we repair, rebuild and custom-build trailers that track straight and tow safe.",
    bullets: ["Boat trailer repairs & rebuilds", "Custom trailer fabrication", "Axle, spring & bunk replacement", "Corrosion cut-outs & re-galvanising prep", "Stone guards & storage boxes"],
  },
];
